import { ca } from '@cian/analytics';

import { NEWBUILDING_SLIDES_COUNT } from '../../../constants/newbuildingsFromDeveloper';

interface ITrackNewbuildingCarouselShowParams {
  newbuildingIds: number[];
  offerId: number;
}

export const trackNewbuildingCarouselShow = (params: ITrackNewbuildingCarouselShowParams) => {
  const { offerId, newbuildingIds } = params;

  const content = newbuildingIds.slice(0, NEWBUILDING_SLIDES_COUNT).map((id, idx) => ({ id, position: idx + 1 }));

  ca('eventSite', {
    action: 'show_sopr',
    category: 'Card',
    label: 'other_JK',
    name: 'oldevent',
    page: {
      extra: {
        is_premium: true,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
        extra: { content },
      },
    ],
  });
};
